import { instances } from '../default-setup';

//Slack
export const getSlackWorkspaces = (params) =>
    instances.get('bot/workspaces/', params);
